export const Z_INDICES = {
  NAV_TABS: 200,
  FLY_ANIMATION: {
    CARD_BACKGROUND: 9997,
    BACKDROP: 9998,
    OVERLAY: 9999,
    CARD_FOREGROUND: 10000,
  },
  ACTIVITY_LAUNCH_COVER: 10001,
  LOADING_HOLD: 99999,
}
